export default function () {
  const initialState = {
    isLoading: true,
    isRefreshing: false,
    supervisor: null,
  }

  return initialState
}
